import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  openBlankPage: "新开页面跳转",
  linkUrl: "跳转地址",
  accessRulers: "访问规则",
  fontFamily: "字体",
  fontSize: "字体大小",
  lineHeight: "行高",
  fontWeight: "字重",
  bgColor: "背景颜色",
  clipSize: "裁剪方式",
  repeatType: "重复方式",
  alignType: "对齐方式",
  color: "字体颜色",
  opacity: "透明度",
  textIsThemeColor: "字体颜色跟随主题色",
  letterSpacing: "字间距",
  fontStyle: "字体样式",
  textDecoration: "下划线",
  textAlign: "对齐方式",
  writingMode: "排列方式",
  borderTopLeftRadius: "边框左上角圆角",
  borderTopRightRadius: "边框右上角圆角",
  borderBottomLeftRadius: "边框左下角圆角",
  borderBottomRightRadius: "边框右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色为主题色",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  iconWidth: "图标大小",
  iconPosition: "图标位置", // 左 右
  iconSrc: "图标链接",
  iconType: "图标类型", // img icon
  iconMargin: "图标文字间距",
  iconColor: "图标颜色",
  iconColorIsThemeColor: "图标颜色跟随主题色",
  "boxShadowColor.0": "阴影颜色1",
  "animateSets.animateType": "动画类型",
  "animateSets.animateDirection": "动画方向",
  "animateSets.animateDuration": "动画持续时间"
}
export const getOptDes = toSelectOpt.bind(this, optDes)



